/** The organization roles an admin can grant, in display order (docs/5-roles-and-workflow.md). */
export const MEMBER_ROLES = ['requester', 'procurement', 'reviewer', 'admin'] as const;
export type MemberRole = (typeof MEMBER_ROLES)[number];
